<div class="astrea-editorial p-sm-4 p-2">
    <div class="container" *ngIf="!loading; else astreaLoading">

        <div class="editorials-link d-flex a-i-center j-c-start mb-3">
            <mat-icon>chevron_left</mat-icon>
            <a [routerLink]="['/editorials']" title="{{ 'pages.editorials.all' | translate }}">{{ 'pages.editorials.all' | translate }}</a>
        </div>

        <div class="astrea-title mb-3">
            <h1>{{ 'pages.title_editorial' | translate }}: {{ editorial.editorial }}</h1>
        </div>

        <div>

            <div id="books" *ngIf="books && books.length > 0; else withoutResults">
                <div class="products-wrapper">
                    <astrea-book-simple
                        *ngFor="let b of books"
                        [book]="b"
                        class="animated astreaFade"
                    ></astrea-book-simple>
                </div>
            </div>

            <ng-template #withoutResults>
                <div class="t-center mt-3">
                    {{ 'pages.without' | translate }}
                </div>
            </ng-template>

            <div>
                <astrea-paginator
                    [itemsPerPage]="itemsPerPage"
                    [totalLength]="totalLength"
                    [pageRedirect]="'/editorial/' + url"
                ></astrea-paginator>
            </div>

        </div>

    </div>

    <ng-template #astreaLoading>
        <astrea-loading
            [text]="'pages.loading' | translate"
        ></astrea-loading>
    </ng-template>

</div>
